import * as React from "react";
import { DeviceType } from "../../../../shared/api-clients/_api";
import "./sensor-dipswitches.scss";

type Props = {
	deviceType: DeviceType.WRF04 | DeviceType.NOVOS3 | DeviceType.REGIN;
};

export const SensorDipswitches: React.FunctionComponent<Props> = ({ deviceType }: Props) => {
	const sensors = {
		[DeviceType.WRF04]: {
			images: (
				<>
					{/* rome-ignore lint/a11y/useAltText: <explanation> */}
					<img
						src={require("./dipswitch-assets/wrf04-temperature-sensor-configuration-left.png")}
						className="sensor__image"
					/>
					{/* rome-ignore lint/a11y/useAltText: <explanation> */}
					<img
						src={require("./dipswitch-assets/wrf04-temperature-sensor-configuration-right.png")}
						className="sensor__image"
					/>
				</>
			),
			text: "Please confirm the dip switches for the sensor match the image below:",
		},
		[DeviceType.NOVOS3]: {
			images: (
				<>
					{/* rome-ignore lint/a11y/useAltText: <explanation> */}
					<img
						className="sensor__image"
						src={require("./dipswitch-assets/novos3-temperature-sensor-configuration-left.png")}
					/>
				</>
			),
			text: "Please confirm the dip switches for the sensor match the image below:",
		},
		[DeviceType.REGIN]: {
			images: (
				<div className="sensor--jumper">
					{/* rome-ignore lint/a11y/useAltText: <explanation> */}
					<img src={require("./dipswitch-assets/regin-dipswitch.png")} className="sensor__image" />
					{/* rome-ignore lint/a11y/useAltText: <explanation> */}
					<img src={require("./dipswitch-assets/regin-jumpers.png")} className="sensor__image--jumper" />
				</div>
			),
			text: "Please confirm the dip switches and jumpers for the sensor match the images below:",
		},
	};
	const sensor = sensors[deviceType];
	return (
		<div>
			<p>{sensor.text}</p>
			<div className="sensor">{sensor.images}</div>
		</div>
	);
};
